(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters-sidebar"] && !Shopify.designMode) return;
  try {
    (function () {
    function isMobileFilterDrawer() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function getFilterShell() {
      return document.querySelector('[data-collection-filters-shell]');
    }

    function syncExternalFilterButtons(expanded) {
      document.querySelectorAll('[data-collection-filters-external-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function linkExternalButtonsToPanel() {
      var shell = getFilterShell();
      var panel = shell && shell.querySelector('.collection-filters__drawer-panel');
      document.querySelectorAll('[data-collection-filters-external-open]').forEach(function (btn) {
        if (panel && panel.id) {
          btn.setAttribute('aria-controls', panel.id);
        } else {
          btn.removeAttribute('aria-controls');
        }
      });
    }

    function syncPanelAria(shell) {
      var panel = shell.querySelector('.collection-filters__drawer-panel');
      if (!panel) {
        return;
      }
      if (!isMobileFilterDrawer()) {
        panel.removeAttribute('aria-hidden');
        return;
      }
      if (shell.classList.contains('is-open')) {
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    function closeFilterShell(shell) {
      shell.classList.remove('is-open');
      document.body.classList.remove('collection-filters-drawer-open');
      syncExternalFilterButtons(false);
      syncPanelAria(shell);
      var ext = document.querySelector('[data-collection-filters-external-open]');
      if (ext && isMobileFilterDrawer()) {
        if (typeof ext.focus === 'function') {
          ext.focus({ preventScroll: true });
        } else {
          ext.focus();
        }
      }
    }

    function openFilterShell(shell) {
      shell.classList.add('is-open');
      document.body.classList.add('collection-filters-drawer-open');
      syncExternalFilterButtons(true);
      syncPanelAria(shell);
      var closeBtn = shell.querySelector('[data-collection-filters-close]');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    function bindFilterShell(shell) {
      syncPanelAria(shell);
    }

    document.querySelectorAll('[data-collection-filters-shell]').forEach(bindFilterShell);

    document.body.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-collection-filters-external-open]');
      if (openBtn) {
        var shellOpen = getFilterShell();
        if (!shellOpen || !isMobileFilterDrawer()) {
          return;
        }
        e.preventDefault();
        if (shellOpen.classList.contains('is-open')) {
          closeFilterShell(shellOpen);
        } else {
          openFilterShell(shellOpen);
        }
        return;
      }
      var scrim = e.target.closest('[data-collection-filters-scrim]');
      if (scrim) {
        var shellScrim = scrim.closest('[data-collection-filters-shell]');
        if (shellScrim) {
          closeFilterShell(shellScrim);
        }
        return;
      }
      var closeBtn = e.target.closest('[data-collection-filters-close]');
      if (closeBtn) {
        var shellClose = closeBtn.closest('[data-collection-filters-shell]');
        if (shellClose) {
          closeFilterShell(shellClose);
        }
      }
    });

    linkExternalButtonsToPanel();

    var mq = window.matchMedia('(max-width: 989px)');
    function onMqChange() {
      if (!mq.matches) {
        document.querySelectorAll('[data-collection-filters-shell].is-open').forEach(closeFilterShell);
        syncExternalFilterButtons(false);
      }
      document.querySelectorAll('[data-collection-filters-shell]').forEach(syncPanelAria);
    }
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') {
        return;
      }
      document.querySelectorAll('[data-collection-filters-shell].is-open').forEach(closeFilterShell);
    });

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-collection-filters-shell]').forEach(syncPanelAria);
      linkExternalButtonsToPanel();
    });

    var forms = document.querySelectorAll('[id^="CollectionFiltersForm-"]');
    forms.forEach(function (form) {
      form.querySelectorAll('input.collection-filters__toggle').forEach(function (input) {
        if (input.type !== 'checkbox' && input.type !== 'radio') {
          return;
        }
        input.addEventListener('change', function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
      form.querySelectorAll('.collection-filters__price-input').forEach(function (input) {
        input.addEventListener('change', function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
